import { GeolocationQuery } from '@water-web/api';

export const GeolocationServiceConstructor = () => ({
  getUserGeolocation: new GeolocationQuery(),
});
